import { Alert, Form } from 'react-bootstrap';

const DonationAmount = ({
    currency = '€',
    amount,
    setAmount,
    error,
}) => {
    return (
        <>
            {error && (
                <Alert variant="danger" className="mb-3">
                    {error}
                </Alert>
            )}

            <div className="donation-amount-wrap">
                <div className="donation-amount-group">
                    <Form.Control
                        className="donation-amount-input"
                        type="number"
                        min={0.05}          // ✅ backend min
                        step={0.01}         // ✅ cents
                        inputMode="decimal" // ✅ better for decimals
                        value={amount}
                        onChange={(e) => setAmount(Number(e.target.value))}
                    />


                    <span className="text-dark donation-amount-currency">
                        {currency}
                    </span>
                </div>

                <div className="text-center donation-amount-hint">
                    Enter the amount
                </div>
            </div>
        </>
    );
};

export default DonationAmount;
